module.exports = __webpack_public_path__ + "images/mdj/members/resume/preview/preview_btn01-d524ed95b3468a42261e744d9bb496bc.jpg";